module.exports = "/_next/static/images/1a110372be1c1a42a5bd13551eff6354-mgm-750.jpg";